import { useTranslation } from "react-i18next";
import useMessageComposer from "./hooks/useMessageComposer";
import { P2 } from "../../components/Paragraph";
// import TextArea from "../forms/TextArea";
import Button from "../../components/Button";
import { useSelector } from "react-redux";
import {
  selectIsRightPanelOpen,
  selectIsRightPanelExpanded,
} from "../../app/layoutSlice";
import Loader from "../../components/Loader";
import MathEditor from "./MathEditor";
import classNames from "classnames";
import styles from "./messageComposer.module.css";

const MessageComposer = ({
  onSubmit,
  onCreateDialog,
  creatingDialog,
  dialogStatus,
  waiting,
  followUps,
}) => {
  const { t } = useTranslation();
  const {
    composerRef,
    composerAttribs,
    onSend,
    dialogStatus: statusFromHook,
    followUpButtons,
  } = useMessageComposer({
    onSubmit,
    onCreateDialog,
    dialogStatus,
    waiting,
    followUps,
  });
  const rightPanelOpen = useSelector(selectIsRightPanelOpen);
  const rightPanelExpanded = useSelector(selectIsRightPanelExpanded);

  let content;
  if (statusFromHook == null || creatingDialog) {
    content = <Loader small />;
  } else if (statusFromHook.toLowerCase() === "wait_for_system") {
    content = <P2>{t("chat.waitingForSystem")}</P2>;
  } else if (statusFromHook.toLowerCase() === "ready") {
    content = (
      <>
        <MathEditor {...composerAttribs} disabled={waiting} />
        <Button important onClick={onSend} disabled={waiting}>
          {t("chat.send")}
        </Button>
        <P2
          style={{
            position: "absolute",
            bottom: "10px",
            left: "20px",
            opacity: waiting ? "0.5" : "1",
          }}
        >
          {t("chat.mathFormulaHint")}
        </P2>
      </>
    );
  } else {
    content = (
      <>
        {followUpButtons?.map((buttonAttribs) => (
          <Button
            key={buttonAttribs.id}
            important
            onClick={buttonAttribs.onClick}
          >
            {buttonAttribs.label}
          </Button>
        ))}
      </>
    );
  }

  return (
    <div ref={composerRef} className={styles.messageComposer}>
      <div
        className={classNames(styles.messageComposerContainerWithMargin, {
          [styles.rightPanelExpanded]: rightPanelOpen && rightPanelExpanded,
          [styles.rightPanelCollapsed]: rightPanelOpen && !rightPanelExpanded,
        })}
      >
        <div className={styles.messageComposerContainer}>{content}</div>
      </div>
    </div>
  );
};

export default MessageComposer;
